import { Instagram, Facebook, Music2, Mail } from "lucide-react";

export const Footer = ({ t }) => {
  const socials = [
    { icon: Instagram, label: "Instagram", testid: "social-instagram" },
    { icon: Facebook, label: "Facebook", testid: "social-facebook" },
    { icon: Music2, label: "TikTok", testid: "social-tiktok" },
  ];
  return (
    <footer data-testid="footer" className="border-t border-[#003940]/10 bg-[#E9F3F4] px-4 py-14">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
        <div>
          <a href="#top" data-testid="footer-logo" className="inline-block">
            <img src="/logo.png" alt="BUNDLER FM" className="h-9 w-auto" />
          </a>
          <p className="mt-3 text-sm text-slate-600">{t.footer.tagline}</p>
          <p data-testid="footer-company" className="mt-3 text-xs font-mono uppercase tracking-[0.15em] text-slate-500">
            {t.footer.company}
          </p>
          <p data-testid="footer-address" className="mt-1 text-xs text-slate-500">
            {t.footer.address} · {t.footer.phone}
          </p>
          <a
            href={`mailto:${t.footer.email}`}
            data-testid="footer-email-link"
            className="mt-4 inline-flex items-center gap-2 text-[#003940] hover:text-[#002A2F] font-mono text-sm underline underline-offset-4 transition-colors"
          >
            <Mail size={15} />
            {t.footer.email}
          </a>
        </div>

        <div className="flex flex-col items-start md:items-end gap-4">
          <div className="flex items-center gap-3">
            {socials.map(({ icon: Icon, label, testid }) => (
              <a
                key={label}
                href="#top"
                data-testid={testid}
                aria-label={label}
                title={`${label} — ${t.footer.socialSoon}`}
                className="w-10 h-10 rounded-full border border-[#003940]/20 bg-white/60 flex items-center justify-center text-[#003940]/70 hover:text-white hover:bg-[#003940] hover:border-[#003940] transition-all duration-200"
              >
                <Icon size={17} />
              </a>
            ))}
          </div>
          <p className="text-xs text-slate-500 font-mono">{t.footer.socialSoon}</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-10 pt-6 border-t border-[#003940]/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-slate-500">{t.footer.rights}</p>
        <div className="flex items-center gap-5">
          <a href="/impressum" data-testid="footer-impressum-link" className="text-xs text-slate-500 hover:text-[#003940] transition-colors font-mono">
            Impressum
          </a>
          <a href="/datenschutz" data-testid="footer-datenschutz-link" className="text-xs text-slate-500 hover:text-[#003940] transition-colors font-mono">
            Datenschutz
          </a>
          <a href="/admin" data-testid="footer-admin-link" className="text-xs text-slate-500 hover:text-[#003940] transition-colors font-mono">
            {t.footer.admin}
          </a>
        </div>
      </div>
    </footer>
  );
};
